module.exports = "/_next/static/videos/01-video-492cbb572a41bf6fc2be6a35d7e7b2e2.mp4";